const Environment = {
  REACT_APP_KEYCLOAK_URL: env('VITE_KEYCLOAK_URL'),
  REACT_APP_SHAFT_VSCODE_DOMAIN: env('VITE_SHAFT_VSCODE_DOMAIN'),
  REACT_APP_GITEA_PUBLIC_HOST: env('VITE_GITEA_PUBLIC_HOST'),
  REACT_APP_ENABLE_AKAMAI_EDGE_DEPLOYMENT: env('VITE_ENABLE_AKAMAI_EDGE_DEPLOYMENT'),
  REACT_APP_LOCAL_HORIZON: env('VITE_LOCAL_HORIZON'),
  REACT_APP_LOCAL_VSCODE: env('VITE_LOCAL_VSCODE'),
  REACT_APP_ENABLE_RPC_TESTING: env('VITE_ENABLE_RPC_TESTING'),
  REACT_APP_S3_EDGE_READ_LAMBDA_DOMAIN_POOL: env('VITE_S3_EDGE_READ_LAMBDA_DOMAIN_POOL'),
  REACT_APP_S3_EDGE_READ_LAMBDA_DOMAIN: env('VITE_S3_EDGE_READ_LAMBDA_DOMAIN'),
};

function env(key: string): string {
  return import.meta.env.MODE === 'development' ? import.meta.env[key] : ((window as any)['DWN_ENV'][key] as string);
}

export default Environment;
